/**
 * 全站共享的展示格式化工具。
 *
 * 之前各视图各自复制 new Date(x).toLocaleString('zh-CN') 达 6+ 份,
 * 口径不一 (有的带 hour12:false, 有的裸 toLocaleString 跟随系统语言)。
 * 所有视图统一改用这里的函数。
 */

/** ISO/时间戳 → "2026-08-15 14:30:05" (24 小时制, 中文区域) */
export function fmtDateTime(input: string | number | Date | null | undefined): string {
  if (!input) return '-'
  const d = new Date(input)
  if (Number.isNaN(d.getTime())) return String(input)
  return d.toLocaleString('zh-CN', { hour12: false })
}

/** ISO/时间戳 → "2026-08-15" */
export function fmtDate(input: string | number | Date | null | undefined): string {
  if (!input) return '-'
  const d = new Date(input)
  if (Number.isNaN(d.getTime())) return String(input)
  return d.toLocaleDateString('zh-CN')
}

/**
 * 小数 → 百分比字符串。
 * value 传原始小数 (0.123 → "12.3%"); 若已是百分数数值请传 { alreadyPercent: true }。
 */
export function fmtPercent(
  value: number | null | undefined,
  digits = 1,
  opts: { alreadyPercent?: boolean } = {}
): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '-'
  const v = opts.alreadyPercent ? value : value * 100
  return `${v.toFixed(digits)}%`
}

/** 金额 → "¥12,345.67"; 大额自动转 万/亿 (中文习惯) */
export function fmtMoney(value: number | null | undefined, digits = 2): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '-'
  const abs = Math.abs(value)
  if (abs >= 1e12) return `¥${(value / 1e12).toFixed(digits)}万亿`
  if (abs >= 1e8) return `¥${(value / 1e8).toFixed(digits)}亿`
  if (abs >= 1e4) return `¥${(value / 1e4).toFixed(digits)}万`
  return `¥${value.toLocaleString('zh-CN', { minimumFractionDigits: digits, maximumFractionDigits: digits })}`
}

/** 提取并格式化 Axios/后端错误响应，避免出现 [object Object] */
export function extractErrorMessage(err: any, fallback = '未知错误'): string {
  if (!err) return fallback
  const detail = err.response?.data?.detail
  if (typeof detail === 'string') return detail
  if (Array.isArray(detail)) {
    return detail
      .map((d: any) => {
        if (typeof d === 'string') return d
        const loc = Array.isArray(d?.loc) ? d.loc.filter((x: any) => x !== 'body').join('.') : ''
        const msg = d?.msg || d?.message || JSON.stringify(d)
        return loc ? `${loc}: ${msg}` : msg
      })
      .join('; ')
  }
  if (detail && typeof detail === 'object') {
    return detail.msg || detail.message || JSON.stringify(detail)
  }
  return err.message || (typeof err === 'string' ? err : fallback)
}

